/**
 * External Dependencies
 */
import 'jquery';
window.$ = window.jQuery = require('jquery');

import { createPopper } from '@popperjs/core';
import { Util, Collapse, OffCanvas, Button, Tooltip, Modal } from 'bootstrap';

import Swiper, { Navigation, Lazy, Autoplay, Thumbs, Pagination } from 'swiper';

import SimpleLightbox from "simplelightbox";

window.bootstrap = require('bootstrap');

$(document).ready(() => {

	var supportsTouch = 'ontouchstart' in window ||
	 window.DocumentTouch && document instanceof window.DocumentTouch ||
	 navigator.maxTouchPoints > 0 ||
	 window.navigator.msMaxTouchPoints > 0;
	 
	if(supportsTouch){

		$('.menu-item-has-children > a').on('click', function( event ){
			event.preventDefault();
			$(this).parents('.menu-item').toggleClass('open');
		});

	}

	/*
	window.addEventListener("scroll", function(event){
		var top = this.pageYOffset;

		if(top > 10){
			$('#header').addClass('bg-primary');
		} else {
			$('#header').removeClass('bg-primary');
		}

	}, {passive:true});
	
	*/

	$('a[href*="#"]', '#content')
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
		var target = $(this.hash);
		target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		if (target.length) {
			event.preventDefault();
			$('html, body').animate({
				scrollTop: target.offset().top,
			}, 1000, function() {
				var $target = $(target);
				$target.focus();
				if ($target.is(':focus')) { 
					return false;
				} else {
					$target.attr('tabindex','-1'); 
					$target.focus();
				}

			});
		}
	});

	var lazyEmbeds = [].slice.call(document.querySelectorAll('video.lazy, iframe.lazy'));

	if ('IntersectionObserver' in window) {
		var lazyEmbedObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(embed) {
				if (embed.isIntersecting) {
					if (typeof embed.target.tagName === 'string' && embed.target.tagName === 'IFRAME') {
						embed.target.src = embed.target.dataset.src;
					} else {
						for (var source in embed.target.children) {
							var embedSource = embed.target.children[source];
							if (typeof embedSource.tagName === 'string' && embedSource.tagName === 'SOURCE') {
								embedSource.src = embedSource.dataset.src;
							}
						}

						embed.target.load();
					}

					embed.target.classList.remove('lazy');
					lazyEmbedObserver.unobserve(embed.target);
				}
			});
		});

		lazyEmbeds.forEach(function(lazyEmbed) {
			lazyEmbedObserver.observe(lazyEmbed);
		});
	}

	var lazyAnimations = [].slice.call(document.querySelectorAll('.animate-intro'));

	if ('IntersectionObserver' in window) {
		var lazyAnimationObserver = new IntersectionObserver(function(entries, observer) {
			entries.forEach(function(element) {
				if (element.isIntersecting) {
					element.target.classList.add('animate');
					element.target.classList.remove('animate-intro');
					lazyAnimationObserver.unobserve(element.target);
				} 
			});
		}, {
			root: null,
			rootMargin: '0px',
			threshold: [0,1],
		});

		lazyAnimations.forEach(function(lazyAnimation) {
			lazyAnimationObserver.observe(lazyAnimation);
		});
	}


	//Live Search
	$(document).on('keyup change', '#search input[type="search"]', function(){
		var $search = $(this), search = $search.val(), $datalist = $search.parents('#search').find('datalist');

		if(search.length >= 3){
			$.get('index.php?route=extension/cyberfox4/startup/theme_cyberfox|liveSearch', {search: search}, function(data, status){
				$datalist.html('');
				$.each(data, function(key, product){

					$datalist.append('<option value="' + product.model + '">' + product.name + ' - ' + product.price + '</option>');
				});
			});
		}

	});

	function initializeLightbox(){
		if($('a[data-featherlight="image"]', '#product-info').length){
			var gallery = new SimpleLightbox('a[data-featherlight="image"]', '#product-info', {
				navText: [
					'<button rel="button" class="btn btn-dark px-3 position-fixed top-50 start-0 translate-middle-y" aria-label="next" tabindex="-1"><i class="fal fa-angle-left" style="width: 1rem;"></i></button>',
					'<button rel="button" class="btn btn-dark px-3 position-fixed top-50 end-0 translate-middle-y" aria-label="previous" tabindex="-1"><i class="fal fa-angle-right" style="width: 1rem;"></i></button>',
					],
				closeText: '&times;',
			});
		}
	}

	initializeLightbox();

	//Slider
	function initSwiper(carousel){
		var $carousel = $(carousel);

		var carouselOptions = {
			slidesPerView : $carousel.data('items') ? $carousel.data('items') 		: 1,
			spaceBetween: 0,
			cssMode: true,
			simulateTouch: true,      
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: $carousel.find('.swiper-button-next')[0],
				prevEl: $carousel.find('.swiper-button-prev')[0],
			},
			breakpoints: {
				414: {},
				576: {},
				768: {},
				992: {},
				1320: {},
			},
		};

		if( $carousel.data('xs-items') ){ 	carouselOptions.breakpoints[414].slidesPerView = parseInt($carousel.data('xs-items')); }
		if( $carousel.data('xs-center') ){ carouselOptions.breakpoints[414].centeredSlides = $carousel.data('xs-center'); }

		if( $carousel.data('sm-items') ){ 	carouselOptions.breakpoints[576].slidesPerView = parseInt($carousel.data('sm-items')); }
		if( $carousel.data('sm-center') ){ carouselOptions.breakpoints[576].centeredSlides = $carousel.data('sm-center'); }

		if( $carousel.data('md-items') ){ 	carouselOptions.breakpoints[768].slidesPerView = parseInt($carousel.data('md-items')); }
		if( $carousel.data('md-center') ){ carouselOptions.breakpoints[768].centeredSlides = $carousel.data('md-center'); }

		if( $carousel.data('lg-items') ){ 	carouselOptions.breakpoints[992].slidesPerView = parseInt($carousel.data('lg-items')); }
		if( $carousel.data('lg-center') ){ carouselOptions.breakpoints[992].centeredSlides = $carousel.data('lg-center'); }

		if( $carousel.data('xl-items') ){ 	carouselOptions.breakpoints[1320].slidesPerView = parseInt($carousel.data('xl-items')); }
		if( $carousel.data('xl-center') ){ carouselOptions.breakpoints[1320].centeredSlides = $carousel.data('xl-center'); }

		if( $carousel.data('lazy') ){ carouselOptions.preloadImages = true; carouselOptions.lazy = true;  }

		if( $carousel.data('autoheight') ){ carouselOptions.autoHeight = true; }



		if( $carousel.data('direction') ){ carouselOptions.direction = $carousel.data('direction');}

		if( $carousel.data('thumbs') ){ 
			var $thumbCarousel = $( $carousel.data('thumbs') );
			if($thumbCarousel.length){
				var	thumbCarousel = $thumbCarousel[0];
				$thumbCarousel.addClass('swiper-container');
				carouselOptions.thumbs = { swiper: initSwiper(thumbCarousel) };
			}  
		}

		var swiper =  new Swiper(carousel, carouselOptions);

		if( $carousel.data('tabs') ){ 
			$carousel.siblings('.nav-tabs').find('.nav-link[data-target]').on('click', function(){
				swiper.slideTo($(this).data('target'));
			});

			swiper.on('slideChange', function () {
				$carousel.siblings('.nav-tabs').find('.nav-link').removeClass('active').attr('aria-selected', 'false');
				$carousel.siblings('.nav-tabs').find('[data-target="' + swiper.activeIndex + '"]').addClass('active').attr('aria-selected', 'true');
			});
		}
		
		return swiper;
	}


	function initSwipers(){
		Swiper.use([Navigation, Lazy, Thumbs, Pagination]);
		$('.swiper-container', '#main').each(function(){
			var carousel = this, $carousel = $(this), items = $carousel.data('items') ?? 1;
			if( $carousel.find('> .swiper-wrapper').children().length > items && (!$carousel.hasClass('no-mobile') || !isMobile)){
				const swiper = new initSwiper(this);
			} 
		});
	}

	if($('.swiper-container', '#main').length){
		if (document.readyState === 'complete') {
			initSwipers();
		} else {
			window.addEventListener('load', (event) => {
				initSwipers();
			}, {passive: true, once: true});
		}
	}

	$('a[href*="tel:"]').on('click', function(){

		if(typeof gtag == 'function'){
			gtag( 'event', 'generate_lead', {
				event_category: 'Contact',
				event_label: 'Telephone',
			});
		} else if(typeof ga == 'function'){
			ga( 'send', {
				hitType: 'event',
				eventCategory: 'Contact',
				eventAction: 'phone',
				event_label: 'Telephone',
			});
		} else {
			window.dataLayer.push({
				event : 'cf7submission',
				event_label: 'Telephone',
			});
		}

	});

	$('a[href*="mailto:"]').on('click', function(){

		if(typeof gtag == 'function'){
			gtag( 'event', 'generate_lead', {
				event_category: 'Contact',
				event_label: 'Email',
			});
		} else if(typeof ga == 'function'){
			ga( 'send', {
				hitType: 'event',
				eventCategory: 'Contact',
				eventAction: 'email',
				event_label: 'Email',
			});
		} else {
			window.dataLayer.push({
				event : 'cf7submission',
				event_label: 'Email',
			});
		}
		
	});

	
	if($('form#product[data-variant-options]').length){
		$(document).on('change', 'select, input', 'form#product[data-variant-options]', function(){
			$.ajax({
				url: 'index.php?route=extension/cyberfox4/startup/theme_cyberfox|getVariant',
				method: 'post',
				cache: true,
				beforeSend: function(){
					$('#button-cart', '#product-info').attr('disabled', 'disabled');
				},
				data: $('form#product[data-variant-options]').serialize(),
			}).done(function( response) {
				if(response !== ''){
					response = $("<div/>").html(response).text();
					$("#content").load(response + ' #content > *', function(){
						initializeLightbox();
						window.history.pushState({}, '', response);
					});
				}
			});

		});
	}



	$('.input-number ~ button[data-operand="add"]').on('click', function(){
		var $quantity = $(this).parent().find('input[type="number"]'),
				 quantity = parseInt($quantity.val()),
						 step = parseInt($quantity.attr('step')) ?? 1;

		$quantity.val( quantity + step );
	});


	$('button[data-operand="minus"] + .input-number').prev().on('click', function(){
		var $quantity = $(this).parent().find('input[type="number"]'),
				 quantity = parseInt($quantity.val()),
						 step = parseInt($quantity.attr('step')) ?? 1,
							min = parseInt($quantity.attr('min')) ?? 1;

		if(quantity - step > min) {
			$quantity.val( quantity - step );
		} else {
			$quantity.val( min );
		}
	});



	const offcanvasCart = document.getElementById('offcanvasCart')
	offcanvasCart.addEventListener('show.bs.offcanvas', event => {

		//Load data
		var temp = $('<div/>');
		temp.load('index.php?route=common/cart|info', function(){
			$('#offcanvasCart', '#header').html( $( temp ).innerHTML );
		});

	}, { passive: true });
	
	(function($bs) {
			const CLASS_NAME = 'has-child-dropdown-show';
			$bs.Dropdown.prototype.toggle = function(_orginal) {
					return function() {
							document.querySelectorAll('.' + CLASS_NAME).forEach(function(e) {
									e.classList.remove(CLASS_NAME);
							});
							let dd = this._element.closest('.dropdown').parentNode.closest('.dropdown');
							for (; dd && dd !== document; dd = dd.parentNode.closest('.dropdown')) {
									dd.classList.add(CLASS_NAME);
							}
							return _orginal.call(this);
					}
			}($bs.Dropdown.prototype.toggle);

			document.querySelectorAll('.dropdown').forEach(function(dd) {
					dd.addEventListener('hide.bs.dropdown', function(e) {
							if (this.classList.contains(CLASS_NAME)) {
									this.classList.remove(CLASS_NAME);
									e.preventDefault();
							}
							e.stopPropagation(); // do not need pop in multi level mode
					});
			});

			// for hover
			document.querySelectorAll('.dropdown-hover, .dropdown-hover-all .dropdown').forEach(function(dd) {
					dd.addEventListener('mouseenter', function(e) {
							let toggle = e.target.querySelector(':scope>[data-bs-toggle="dropdown"]');
							if (!toggle.classList.contains('show')) {
									$bs.Dropdown.getOrCreateInstance(toggle).toggle();
									dd.classList.add(CLASS_NAME);
									$bs.Dropdown.clearMenus();
							}
					});
					dd.addEventListener('mouseleave', function(e) {
							let toggle = e.target.querySelector(':scope>[data-bs-toggle="dropdown"]');
							if (toggle.classList.contains('show')) {
									$bs.Dropdown.getOrCreateInstance(toggle).toggle();
							}
					});
			});
	})(bootstrap);


	//Modifications
	$( document ).ajaxComplete(function( event, xhr, settings ) {
		if(typeof xhr.responseJSON != 'undefined'){

			if( settings.url.indexOf('account/wishlist|add') !== -1  || settings.url.indexOf('removeWishlist') !== -1 ){

					var product_id = new URLSearchParams(settings.data).get('product_id');

					if( settings.url.indexOf('account/wishlist|add') !== -1 ){
							$( '.add-to-wishlist', '.product-' + product_id).hide();
							$( '.remove-from-wishlist', '.product-' + product_id).show();
					} else {
							$( '.add-to-wishlist', '.product-' + product_id).show();
							$( '.remove-from-wishlist', '.product-' + product_id).hide();
					}

					$( '#wishlist' ).load( 'index.php?route=extension/cyberfox4/startup/theme_cyberfox|wishlist');


			} else if( settings.url.indexOf('product/compare|add') !== -1 || settings.url.indexOf('removeCompare') !== -1 ){

					var product_id = new URLSearchParams(settings.data).get('product_id');

					if( settings.url.indexOf('product/compare|add') !== -1 ){
							$( '.add-to-compare', '.product-' + product_id).hide();
							$( '.remove-from-compare', '.product-' + product_id).show();
					} else {
							$( '.add-to-compare', '.product-' + product_id).show();
							$( '.remove-from-compare', '.product-' + product_id).hide();
					}

					$( '#compare' ).load( 'index.php?route=extension/cyberfox4/startup/theme_cyberfox|compare');

			}

		}
	});


});